import React from "react";
import Header from "@/components/kip/Header";
import Hero from "@/components/kip/Hero";
import Stats from "@/components/kip/Stats";
import About from "@/components/kip/About";
import Metiers from "@/components/kip/Metiers";
import Wayne from "@/components/kip/Wayne";
import Vision from "@/components/kip/Vision";
import Groupe from "@/components/kip/Groupe";
import Contact from "@/components/kip/Contact";
import Footer from "@/components/kip/Footer";
import useReveal from "@/hooks/useReveal";

export default function Landing() {
  useReveal();
  return (
    <div data-testid="landing-page" className="bg-white">
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <Metiers />
        <Wayne />
        <Vision />
        <Groupe />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
